import { Text } from "@certn/cascadia";
import { ActionBar, Illustration, Layout, mq } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { AppFooter } from "../../components/app-footer";
import { AppHeader } from "../../components/app-header";
import { useQueryParams } from "../../hooks/useQueryParams";

export function AlreadyRegistered() {
  const { t } = useTranslation();
  const { params } = useQueryParams();
  const navigate = useNavigate();
  const { email } = params;

  return (
    <Layout
      layout="applicant/narrow"
      header={<AppHeader hideSettings showLoginButton />}
      footer={<AppFooter />}
      testID="already-registered-page-layout"
    >
      <div className={styles.contentContainer}>
        <div className={styles.textContent}>
          <Text style="global/title-small" testID="already-registered-title">
            <Trans>Your email has already been registered</Trans>
          </Text>
          <Text
            style="form/body-primary"
            color="text-weak"
            testID="already-registered-message"
          >
            {email ? (
              <Trans>
                The email you entered, {email}, has already been used by this
                application link. Sign in to view the details of your
                application.
              </Trans>
            ) : (
              <Trans>
                The email you entered has already been used by this application
                link. Sign in to view the details of your application.
              </Trans>
            )}
          </Text>
        </div>
        <Illustration name="success" />
        <ActionBar
          primaryText={t("Sign in")}
          backText={t("Back")}
          onPrimaryClick={() => navigate("/")}
          onBackClick={() => navigate(-1)}
        />
      </div>
    </Layout>
  );
}

const styles = {
  contentContainer: css(
    {
      display: "flex",
      flexDirection: "column",
      gap: "var(--space-6)",
      alignItems: "center",
      margin: "auto",
    },
    mq({
      maxWidth: ["100%", 560],
    })
  ),
  textContent: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-5)",
  }),
};
